import React from 'react'
import { useWillPipe } from '@morningtrain/react-pipelines'
import useSpawner from './use-spawner'

export default function SpawnComponentOnPipe ({ component = null, forwardProps = {} }) {
  const spawner = useSpawner()

  useWillPipe((p) => {
    spawner.spawn(component, forwardProps)

    return p
  }, [spawner, component, forwardProps])

  return null
}
